import { styled } from '@mui/material/styles';
import { css } from '@emotion/react';

export const StyledUiAutocomplete = styled('div')(
  ({ theme }) => css`
    &.error {
      .MuiOutlinedInput-notchedOutline {
        border: 1px solid #d32f2f !important;
      }
    }

    .MuiFormHelperText-root {
      color: #d32f2f;
      margin: 3px 5px 0;
      display: block;
      font-size: 0.625rem;
      text-align: right;
      font-family: inherit !important;
    }

    .MuiChip-root {
      height: 28px;
      padding: 4px 8px;
      border-radius: 6px;
    }
    .MuiChip-label {
      color: ${theme.palette.gray.dark} !important;
      font-weight: ${theme.typography.captionLight.fontWeight};
      font-size: ${theme.typography.captionLight.fontSize};
      padding: 0;
    }

    .location-chips {
      display: flex;
      flex-wrap: wrap;
      gap: 8px;
    }
  `
);
